module.exports = __webpack_public_path__ + "static/media/11.b7ceef99.jpeg";